import decode from 'jwt-decode';
import { IdToken } from '~/contracts/common';
import { type ShareData } from '~/hooks/common/useShareLink';
import BrowserCookies from './BrowserCookies';

export { default as abbreviateLargeNumber } from './abbreviateLargeNumber';
export { default as safeParse } from './safeParse';
export { BrowserCookies };

export const wait = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

function copyToClipboardFallback() {
  // document.execCommand is deprecated in most browsers
  // so this only helps old versions of Safari
  const shareElement = document.createElement('input') as HTMLInputElement;
  const range = document.createRange();
  const selection = window.getSelection();

  document.body.append(shareElement);
  // Generic styles so view doesn't move.
  shareElement.style.position = 'fixed';
  shareElement.style.top = '0';
  shareElement.style.fontSize = '16px';

  shareElement.value = window.location.href;
  shareElement.type = 'text';
  shareElement.contentEditable = 'true';
  shareElement.readOnly = false;

  range.selectNodeContents(shareElement);

  if (selection) {
    selection.removeAllRanges();
    selection.addRange(range);
  }

  shareElement.blur();
  shareElement.setSelectionRange(0, shareElement.value.length);

  document.execCommand('copy');
  shareElement.remove();

  return Promise.resolve();
}

export function shareOrCopyUrl(isMobile: boolean, shareData: ShareData = {}) {
  const url = new URL(window.location.pathname, window.location.origin);
  url.searchParams.set('utm_source', 'vdp-social-share');

  if (isMobile && navigator.share && navigator.canShare(shareData)) {
    return navigator.share({ url: url.href, ...shareData });
  }

  return navigator.clipboard?.writeText
    ? navigator.clipboard.writeText(url.href)
    : copyToClipboardFallback();
}

export function getUserId(
  cookieValue: string | undefined = BrowserCookies.get('CVIdToken')
): string | undefined {
  if (!cookieValue) return undefined;

  try {
    const decodedToken = decode<IdToken>(cookieValue) || {};
    const isExpired = decodedToken.exp * 1000 < Date.now();

    return isExpired ? undefined : decodedToken.user_id;
  } catch (e) {
    return undefined;
  }
}
